export const API_CHANGE_PROFILE="/gateway/identity/users/profile";
export const API_GET_PROFILE="/gateway/identity/users/profile"